import { render, staticRenderFns } from "./BaseFilesList.vue?vue&type=template&id=fa9150dc&scoped=true&"
import script from "./BaseFilesList.vue?vue&type=script&lang=js&"
export * from "./BaseFilesList.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilesList.vue?vue&type=style&index=0&id=fa9150dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9150dc",
  null
  
)

export default component.exports